import { FaCheck } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import CardNotificacaoBase from "./CardNotificacaoBase";

const CardAgendamentoRealizado = ({ notif }) => {
    const navigate = useNavigate();
    const info = notif.atendimento_info;

    if (!info) return null;

    const titulo = `Agendamento Realizado`;
    const descricao = `Paciente: ${info.beneficiario_nome} - Programa: ${info.programa_nome}`;
    
    // Prioriza data da notificação
    let dataDisplay = notif.data_criacao || "-";
    
    // Se não for pré-formatada (ex: não tem barra), tentamos formatar
    if (dataDisplay !== "-" && !dataDisplay.includes("/")) {
        try {
            dataDisplay = new Date(dataDisplay).toLocaleString("pt-BR");
        } catch (e) {
            // Mantém original se falhar
        }
    }

    const handleClick = () => {
        const identificador = info.uuid || info.id;
        navigate(`/atendimentos/edit/${identificador}/?aba=agendamentos`);
    };

    return (
        <CardNotificacaoBase
            notificacao={notif}
            icon={<FaCheck />}
            color="success"
            text="text-success"
            label="Realizado"
            titulo={titulo}
            descricao={descricao}
            dataFormatada={dataDisplay}
            onClick={handleClick}
        />
    );
};

export default CardAgendamentoRealizado;
